import { useOutletContext } from 'react-router'
import { PhotosetFinal } from '@/features/photoset/components/photoset-final'
import { useGetNeedManualRetouchingSpaces } from '@/features/photoset/queries/use-get-need-manual-retouching-spaces'
import { GET_PHOTOSET_IMAGES_LIST_RESPONSE_TYPE } from '@/features/photoset/queries/use-get-photoset-images-list'
import type { PhotosetURLParams } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'

export const PhotosetAiVettingCompletedStep = () => {
	const { t } = useTranslation()
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()

	// queries
	const { data: photosetSpaces, isFetching } =
		useGetNeedManualRetouchingSpaces({
			urlParams: {
				photosetId: urlParams.id
			},
			params: {
				response_type: GET_PHOTOSET_IMAGES_LIST_RESPONSE_TYPE,
				is_final_select: true
			}
		})

	const manuallyRetouchedCounter =
		photosetSpaces?.reduce((count, photosetSpace) => {
			return (
				count +
				photosetSpace.images.filter(
					(image) => image.is_manually_retouched || image.is_revised
				).length
			)
		}, 0) || 0

	return (
		<PhotosetFinal
			isLoading={isFetching}
			status='success'
			subtitle={
				photosetSpaces && manuallyRetouchedCounter > 0
					? t('photoset:manual_retouching_completed.subtitle_image', {
							count: manuallyRetouchedCounter
						})
					: t('photoset:ai_vetting_completed.subtitle')
			}
			title={
				photosetSpaces && manuallyRetouchedCounter > 0
					? t('photoset:manual_retouching_completed.title')
					: t('photoset:ai_vetting_completed.title')
			}
		/>
	)
}

PhotosetAiVettingCompletedStep.displayName = 'PhotosetAiVettingCompletedStep'
